import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { ReactChildren, useContext, useEffect } from "react";
import { PaymentContext, usePaymnetContext } from ".";

const client = axios.create({
    baseURL: process.env.REACT_APP_CHECKOUT_SERVICE_URL,
})

// export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
//     axiosInstance.interceptors.request.use(onRequest, onRequestError);
//     axiosInstance.interceptors.response.use(onResponse, onResponseError);
//     return axiosInstance;
// }

export const AxiosInterceptor = ({ children }: { children: any }) => {

    const { state, update } = usePaymnetContext();

    const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
        // console.info(`[request] [${JSON.stringify(config)}]`);

        return config;
    }

    const onRequestError = (error: AxiosError): Promise<AxiosError> => {
        // console.error(`[request error] [${JSON.stringify(error)}]`);
        return Promise.reject(error);
    }

    const onResponse = (response: AxiosResponse): AxiosResponse => {
        // console.info(`[response] [${JSON.stringify(response)}]`);
        return response;
    }

    const onResponseError = (error: AxiosError): Promise<AxiosError> => {
        console.error(`[response error] [${JSON.stringify(error)}]`);
        update({
            ...state,
            success: false,
            systemMessage: {
                ...state.systemMessage,
                show: true,
                title: error?.code,
                message: error.message
            }
        });

        return Promise.reject(error);
    }

    useEffect(() => {
        const requestInterceptors = client.interceptors.request.use(onRequest, onRequestError);
        const responseInterceptors = client.interceptors.response.use(onResponse, onResponseError);

        return () => {
            client.interceptors.request.eject(requestInterceptors);
            client.interceptors.response.eject(responseInterceptors);
        }

    }, []);

    return children;
}

export default client;
